import React from 'react'
import '../style/Awards.css'
import GameJemPic from '../img/GameJem.jpg'

const Awards = () => {
  return (
    <div data-aos="fade-in" >

      <h1>Awards</h1>
      <div className='award-img'>
        <img src={GameJemPic} alt='Game Jem Haifa Third Place Award' />
      </div>

      <div className='award-title'>
        <h2>Third Place Global Game Jem Haifa </h2>
      </div>
    </div>
  )
}

export default Awards